module.exports = __webpack_public_path__ + "NJ_logo-fcbb8236688a99042d87.png";